/**
 * Common response extraction helpers - avoids repeating response?.data?.list ?? response?.list ?? [] patterns
 */
export const extractList = (response) =>
  response?.data?.list ?? response?.data?.data?.list ?? response?.list ?? (Array.isArray(response) ? response : []);

export const extractData = (response) => response?.data ?? response;

export const extractPagination = (response) =>
  response?.data?.pagination ?? response?.pagination ?? { total: 0, page: 1, per_page: 10 };
